
namespace TabAurous.Production {

    @Serenity.Decorators.registerClass()
    export class JWReceiptInspectionValuesGrid extends Serenity.EntityGrid<JWReceiptInspectionValuesRow, any> {
        protected getColumnsKey() { return 'Production.JWReceiptInspectionValues'; } 
        protected getIdProperty() { return JWReceiptInspectionValuesRow.idProperty; }
        protected getInsertPermission() { return JWReceiptInspectionValuesRow.insertPermission; }
        protected getLocalTextPrefix() { return JWReceiptInspectionValuesRow.localTextPrefix; }
        protected getService() { return JWReceiptInspectionValuesService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}